import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderView = _resolveComponent("HeaderView")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderView),
    _createElementVNode("div", {
      class: _normalizeClass(["container-fluid p-0", {
      'container-fluid-full-menu': _ctx.isFullHeader,
      'container-fluid-mobile-menu': !_ctx.isFullHeader,
    }]),
      style: {"word-break":"break-all","background-color":"#fbfbfb","overflow-x":"hidden"}
    }, [
      ($data.isRouterAlive)
        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_Footer)
  ], 64))
}